
import BaseMixin from '@/views/mixin.vue'
import compSearch from './search'
import { mapState,mapGetters} from "vuex";
import {
    HttpB2cAllUnshippedList,
    HttpCancelOrder,
    HttpRecoveryNormal,
} from '@/service/boss/b2corder'
import cancelorder from '../alert/cancelorder'
import comAddnotes from '../alert/addnotes'
import comIndex from './indexView'
import { DropdownMenu, Dropdown, DropdownItem, Icon, Button } from 'view-design'

export default {
    mixins: [BaseMixin],
    components: {
        compSearch,
        cancelorder,
        comAddnotes,
        comIndex,
        compUpload: () =>  import("@components/templates/upload"),
    },
    data() {
        return {
            isSuper: this.$store.state.userinfo.isSuper,
            hongren:'/picture/hongren.png',
            prime:'/picture/prime.png',
            bufa:'/picture/bufa.png',
            fudingdan:0,
            formData: {
                page: 1,
                rows: 10,
                sidx: 'warehouseExpectedShipDate asc,isPrime,systemShipServiceLevel',
                sord: 'desc',
            },
        };
    },
    methods: {
        httpList: HttpB2cAllUnshippedList,
        handleOperate(data, type) {
            this.operate = {};
            switch (type) {
                case 'query':
                    this.operate = {
                        show:true,
                        width:1200,
                        component: "comIndex",
                        activeids:data,
                        querytype:'query'
                    }
                    break;
                case 'queryBlank':
                    const url = this.$router.resolve({
                        name: 'errorderUpdate',
                        params: { type: 'query' },
                        query: { id: data },
                    });
                    window.open(url.href, '_blank');
                    break;
                case 'edit': {
                    const url = this.$router.resolve({
                        name: 'errorderUpdate',
                        params: { type: 'edit' },
                        query: { id: data },
                    });
                    window.open(url.href, '_blank');
                    break;
                }
                case 'cancel': {
                    this.operate = {
                        title: this.$t('erp.b2c.cancel_order',{defaultValue:'取消订单'}),
                        show:true,
                        width:600,
                        component: "cancelorder",
                        type,
                        id:data,
                    }
                    break;
                }
                case 'backnormal': {
                    this.checkedId = !data ? this.checkedId : [data];
                    if (this.checkedId.length == 0) {
                        this.$Message.warning(this.$t('global.common.choose_one', { defaultValue: '请选择至少一条数据' }));
                        return;
                    }
                    this.showDel = true;
                    this.operate = {
                        title: this.$t("erp.b2c.back_normal", { defaultValue: "恢复正常" }),
                        desc: this.$t('erp.b2c.backnormal_desc',{defaultValue:'确定要将订单恢复为正常处理的订单？'}),
                        type,
                    }
                    break;
                }
                case 'addnotes': {
                    this.checkedId = !data ? this.checkedId : [data];
                    if (this.checkedId.length == 0) {
                        this.$Message.warning(this.$t('global.common.choose_one', { defaultValue: '请选择至少一条数据' }));
                        return;
                    }
                    this.operate = {
                        title: this.$t("erp.b2c.add_notes", {
                            defaultValue: "添加备注",
                        }),
                        show:true,
                        width:600,
                        component: "comAddnotes",
                        activeids:this.checkedId,
                    }
                    break;
                }
            }
        },

        async batchOpearte() {
            let request, { type, id } = this.operate, params = {}, callback = (res) => { this.$Message.success({content:res.message,duration: 10,closable: true}); };
            switch (type) {
                case 'backnormal': request = HttpRecoveryNormal; params = { orderIds: this.checkedId.join(','),recoveryNormal:1}; break;
                case 'cancel': request = HttpCancelOrder; params = { orderId:this.operate.id }; break;
            }
            if (!request) return;
            request(params).then(res => {
                this.$Message.success({content:res.message,duration: 10,closable: true});
                this.updateList();
                // console.log(this.checkedId)
            }, err => {
                this.$Message.error({content:err.message,duration: 10,closable: true});
            }).finally(result => {
                this.showDel = false;
                this.operate = {};
            });
        },
        filterTime(val){
            // console.log(val,'valcalval')
            
            if (val != null) {
                // let oldTimes1 = val.replace("T"," ").replace("+00:00","");

                // let date = new Date(oldTimes1);
                // var time = date.getTime();
                // var beforeTime = time - 8*60*60*1000;
                // var d = new Date(beforeTime);


                // var year = d.getFullYear(),
                //     month = ("0" + (d.getMonth() + 1)).slice(-2),
                //     sdate = ("0" + d.getDate()).slice(-2),
                //     hour = ("0" + d.getHours()).slice(-2),
                //     minute = ("0" + d.getMinutes()).slice(-2),
                //     second = ("0" + d.getSeconds()).slice(-2);
                // // 拼接
                // var batchTime = year + "-"+ month +"-"+ sdate +"T"+ hour +":"+ minute +":" + second+"-08:00";

                let batchTime = this.$momenttimezone(val).tz("America/Los_Angeles").format();
                // console.log(this.$momenttimezone(val).tz("America/Los_Angeles").format())

                return batchTime;
            }else{
                return "-";
            }
        },
        filterTimeDate(val){
            // console.log(val)
            if (val != null) {
                let batchTime = this.$momenttimezone(val).tz("America/Los_Angeles").format();

                return batchTime.split("T")[0]
            }else{
                return "-";
            }
        },

    },
    computed: {
        ...mapState('boss',['productLineAll']),
        ...mapGetters('dictionary', ['getOrgList','getNewAllWarehouseIdList']),
        columns() {
            let _this = this;
            // this.title =  "待发货列表"
            let datalist = [{
                type: 'selection',
                width: 60,
            }, {
                title: this.$t('global.common.operation',{defaultValue:'操作'}),
                width: 100,
                render: (h, { row }) => {
                    const id = row.id, status = row.orderStatus;
                    return <Dropdown placement="bottom-start" trigger="click">
                        <Button size='small' type='info'>{this.$t('global.common.operation',{defaultValue:'操作'})} &nbsp;<Icon type="md-arrow-dropdown" /></Button>
                        <DropdownMenu slot="list" class="text-left">
                            <DropdownItem class='splitline' nativeOnClick={this.handleOperate.bind(this, id, 'query',row.parentId)}>{this.$t('global.common.operation_see',{defaultValue:'查看'})}</DropdownItem>
                        </DropdownMenu>
                    </Dropdown >
                }
            },
            {
                title:this.$t('fbb.bill.organization',{defaultValue:'组织'}),
                    width:100,
                    render: (h, { row }) => {
                const id = row.orgId;
                const org = this.getOrgList.filter((item) => {
                    return id == item.value
                })[0] || {};
                return <div>
                        <div><span class="font-bold">{org.label}</span></div>
                        </div>
            },
            },
            {
                title:  this.$t('erp.b2c.table_title2',{defaultValue:'账号/项目/订单号/平台订单号'}),
                render: (h, { row }) => {
                    const id = row.lineId;
                    const product = this.productLineAll.filter((item) => {
                        return id == item.id
                    })[0] || {};
                    var urgent = false;
                    if (row.saleOrderDetails.systemShipServiceLevel==1) {
                        urgent = true;
                    }
                    return <div>
                        <div>{row.channelFlag}[{row.channel}]</div>
                        <div><span class="font-bold">{product.name||'-'}</span></div>
                        <div>
                            <a onClick={this.handleOperate.bind(this, row.id, 'query', row.parentId)}>{row.id}</a>
                        </div>
                        <div>
                            <Tooltip placement="top" content={this.$t('erp.b2c.table_urgentorder',{defaultValue:'加急订单（最晚发货时间在24小时内）'})}>
                                <span v-show={urgent} class="order-urgent-span margin-right-10" style="cursor: pointer;">{this.$t('erp.b2c.table_urgent',{defaultValue:'急'})}</span>
                            </Tooltip>{row.orderNo}
                        </div>
                    </div>

                },
            },
            {
                title: this.$t('erp.b2c.table_title5',{defaultValue:'仓库/发货Carrier/发货方式'}),
                // width:200,
                render: (h, { row }) => {
                    if(row.orgWarehouseId!=0){
                        const id = row.orgWarehouseId,
                            result = this.getNewAllWarehouseIdList.filter((item) => {
                                return item.value == id;
                            })[0] || {};

                        return <div>
                                <div>{result.label}</div>
                                <div>{row.saleOrderDetails.carrier ||'-'}</div>
                                <div>{row.shippingMethodCode ||'-'}</div>
                            </div>
                    }else{
                        return <div>
                            <div>{this.$t('erp.b2c.table_title5_desc',{defaultValue:'未分配到仓库'})}</div>
                            <div>{row.saleOrderDetails.carrier ||'-'}</div>
                            <div>{row.shippingMethodCode ||'-'}</div>
                        </div>
                    }

                },

            },
            {
                title:this.$t('erp.b2c.table_title6',{defaultValue:'订单类型/标记/标签'}),
                width:170,
                render:(h, { row })=>{
                    var ordertype;
					switch (row.orderType) {
                        case 'normally': ordertype = <div class="b2ccolor-dark-primary font-weight span-padding">{this.$t('erp.b2c.ordertype_normally',{defaultValue:'正常销售'})}</div>; break;
						case 'celebrity': ordertype = <div class="b2ccolor-error font-weight span-padding">{this.$t('erp.b2c.ordertype_celebrity',{defaultValue:'展示订单'})}</div>; break;
						case 'distribution': ordertype = <div class="b2ccolor-success font-weight span-padding">{this.$t('erp.b2c.ordertype_distribution',{defaultValue:'分销订单'})}</div>; break;
						case 'brush': ordertype = <div class="b2ccolor-warning font-weight span-padding">{this.$t('erp.b2c.ordertype_brush',{defaultValue:'刷评订单'})}</div>; break;
                        case 'DELIVERY': ordertype = <div class="b2ccolor-warning font-weight span-padding">{this.$t('erp.b2c.ordertype_delivery',{defaultValue:'发货订单'})}</div>; break;
					}
                    const urls = {
                        isCelebrity:'/picture/hongren.png',
                        isSample:'/picture/yangpin.png',
                        isReshipment:'/picture/bufa.png',
                        isDismantlementfu:'/picture/chaifu.png',
                        isDismantlementzi:'/picture/chaizi.png',
                        isAddition:'/picture/lipin.png',
                    }
                    const titles = {
                        isCelebrity:this.$t('erp.b2c.redpeople_order',{defaultValue:'红人订单'}),
                        isSample:this.$t('erp.b2c.sample_order',{defaultValue:'样品订单'}),
                        isReshipment:this.$t('erp.b2c.replacement_order',{defaultValue:'补发订单'}),
                        isDismantlementfu:this.$t('erp.b2c.unpackparent_order',{defaultValue:'拆解父订单'}),
                        isDismantlementzi:this.$t('erp.b2c.unpackson_order',{defaultValue:'拆解子订单'}),
                        isAddition:this.$t('erp.b2c.gift_order',{defaultValue:'礼品订单'}),
                    }
                    var imgs = ['isCelebrity','isSample','isReshipment','isDismantlement','isAddition'].map((val)=>{
                        if( val =='isDismantlement' &&row['isDismantlement'] == 'Y' && row.parentId == 0){

                            return h('span',[
                                h('Tooltip',{
                                    props:{
                                        placement:'top',
                                        transfer:true,
                                        content:titles['isDismantlementfu']
                                    }
                                },[
                                    h('img',{
                                        attrs:{
                                            src:urls['isDismantlementfu'],
                                            style:"width:20px;height:20px;cursor: pointer;"
                                        },
                                    })
                                ])
                            ])
                            // return <img style="width:20px;height:20px;cursor: pointer;" src={urls['isDismantlementfu']} title={titles['isDismantlementfu']}  alt={titles['isDismantlementfu']} />


                        }else if(val =='isDismantlement' && row['isDismantlement'] == 'Y' && row.parentId !=0 ){

                            return h('span',[
                                h('Tooltip',{
                                    props:{
                                        placement:'top',
                                        transfer:true,
                                        content:titles['isDismantlementzi']
                                    }
                                },[
                                    h('img',{
                                        attrs:{
                                            src:urls['isDismantlementzi'],
                                            style:"width:20px;height:20px;cursor: pointer;"
                                        },
                                    })
                                ])
                            ])
                            // return <img style="width:20px;height:20px;cursor: pointer;" src={urls['isDismantlementzi']} title={titles['isDismantlementzi']} alt={titles['isDismantlementzi']}/>
                        }else{

                            return row[val]== 'Y' ? h('span',[
                                h('Tooltip',{
                                    props:{
                                        placement:'top',
                                        transfer:true,
                                        content:titles[val]
                                    }
                                },[
                                    h('img',{
                                        attrs:{
                                            src:urls[val],
                                            style:"width:20px;height:20px;cursor: pointer;"
                                        },
                                    })
                                ])
                            ]) : ''

                            // return row[val]== 'Y' ? <img style="width:20px;height:20px;cursor: pointer;" src={urls[val]} title={titles[val]} alt={titles[val]}/> : ''
                        }
                    })
                    var orderFont;

                    if(row.isPrime == 'Y'){
                        orderFont = <span class="b2cfont-italic b2ccolor-info">Prime</span>
                    }else if(row.isOnsite == 'Y'){
                        orderFont = <span class="b2cfont-italic b2ccolor-content">Onsite</span>
                    }else if(row.isBusinessOrder == 'Y'){
                        orderFont = <span class="b2cfont-italic b2ccolor-error">Business</span>
                    }else if(row.shipmentType == 1){
                        orderFont = <span class="b2cfont-italic b2ccolor-warning">Store</span>
                    }

                    var errorcode;
                    switch (row.errorCode) {
                        // case 'unexception': errorcode = '无异常的订单'; break;
						case 'systemException': errorcode = this.$t('erp.b2c.errorcode_systemException',{defaultValue:'系统异常'}); break;
						case 'produceException': errorcode = this.$t('erp.b2c.errorcode_produceException',{defaultValue:'商品无法关联'}); break;
						case 'addressException': errorcode = this.$t('erp.b2c.errorcode_addressException',{defaultValue:'订单地址异常'}); break;
                        case 'updateException': errorcode = this.$t('erp.b2c.errorcode_updateException',{defaultValue:'订单更新异常'}); break;
						case 'pickingException': errorcode = this.$t('erp.b2c.errorcode_pickingException',{defaultValue:'订单配货异常'}); break;
						case 'cancelException': errorcode = this.$t('erp.b2c.errorcode_cancelException',{defaultValue:'订单取消异常'}); break;
						case 'trackingException': errorcode = this.$t('erp.b2c.errorcode_trackingException',{defaultValue:'Tracking异常'}); break;
                        case 'costException': errorcode = this.$t('erp.b2c.errorcode_costException',{defaultValue:'订单成本异常'}); break;
						case 'carrierException': errorcode = this.$t('erp.b2c.errorcode_carrierException',{defaultValue:'订单发运方式异常'}); break;
                        case 'uploadException': errorcode = this.$t('erp.b2c.errorcode_uploadException',{defaultValue:'订单附件上传异常'}); break;
                        case 'purchaseException': errorcode = this.$t('erp.b2c.errorcode_buylabelException', { defaultValue: '购买面单异常' }); break;
                    }
                    return <div>
                        <div>{ordertype}{imgs}</div>
                        <div>{orderFont}</div>
                        <div v-show={errorcode}><span class="error-span margin-right-10">{errorcode}</span></div>
                    </div>
                }
            },

                {
                    title:this.$t('erp.b2c.search_orderstatus',{defaultValue:'订单状态'}),
                    width:90,
                    render: (h, { row }) => {
                        switch (row.orderStatus) {
                            case 'pending': return <Button class="b2cspan-error span-padding">{this.$t('erp.b2c.orderstatus_pending',{defaultValue:'未支付'})}</Button>; break;
                            case 'unshipped': return <Button class="b2cspan-middle-content span-padding">{this.$t('erp.b2c.orderstatus_unshipped',{defaultValue:'未发货'})}</Button>; break;
                            case 'approved': return <Button class="b2cspan-success span-padding">{this.$t('erp.b2c.orderstatus_approved',{defaultValue:'已审核'})}</Button>; break;
                            case 'assigned': return <Button class="b2cspan-primary span-padding">{this.$t('erp.b2c.orderstatus_assigned',{defaultValue:'已分配'})}</Button>; break;
                            case 'picked': return <Button class="b2cspan-info span-padding">{this.$t('erp.b2c.orderstatus_picked',{defaultValue:'已配货'})}</Button>; break;
                            case 'shipped': return <Button class="b2cspan-light-content span-padding">{this.$t('erp.b2c.orderstatus_shipped',{defaultValue:'已发货'})}</Button>; break;
                            case 'canceled': return <Button class="b2cspan-warning span-padding">{this.$t('erp.b2c.orderstatus_canceled',{defaultValue:'已取消'})}</Button>; break;
                            case 'refunded': return <Button class="b2cspan-dark-primary span-padding">{this.$t('erp.b2c.orderstatus_refunded',{defaultValue:'已退款'})}</Button>; break;
                        }

                    },

                },


            {
                title: this.$t('erp.b2c.create_latest_shipping',{defaultValue:'创建/最晚发货/仓库最晚发货时间'}),
                width:200,
                render: (h, { row }) => {
                    return <div>
                        <div>{_this.filterTime(row.channelCreated)}</div>
                        <div>{_this.filterTimeDate(row.latestShipDate)}</div>
                        <div>{_this.filterTimeDate(row.saleOrderDetails.warehouseExpectedShipDate) ||'-'}</div>
                    </div>

                },
            },

            ];

            if(this.$route.name=='b2cOrder'){
                datalist.splice(8,1)
            }
            return datalist;
        },
    },

};




